<h1 mat-dialog-title>Edición cliente</h1>
<div mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="save()">
    <mat-form-field class="margin-right-small">
      <input
        matInput
        placeholder="Razón social"
        formControlName="BusinessName"
        required
      />
      <mat-error
        *ngIf="f.BusinessName.errors && f.BusinessName.errors.required"
      >
        Ingrese la razón social
      </mat-error>
    </mat-form-field>

    <mat-form-field class="margin-right-small">
      <input matInput placeholder="Cuit" formControlName="TaxId" required />
      <mat-error *ngIf="f.TaxId.errors && f.TaxId.errors.required">
        Ingrese el Cuit
      </mat-error>
    </mat-form-field>

    <mat-form-field class="margin-right-small">
      <input
        matInput
        placeholder="Teléfono"
        formControlName="PrimaryPhone"
        required
      />
      <mat-error
        *ngIf="f.PrimaryPhone.errors && f.PrimaryPhone.errors.required"
      >
        Ingrese el teléfono
      </mat-error>
    </mat-form-field>

    <mat-form-field class="margin-right-small">
      <input matInput placeholder="Email" formControlName="Email" required />
      <mat-error *ngIf="f.Email.errors && f.Email.errors.required">
        Ingrese el email
      </mat-error>
    </mat-form-field>

    <mat-form-field class="margin-right-small">
      <mat-label>Tipo contribuyente</mat-label>
      <mat-select formControlName="taxpayerType" name="taxpayerType" required>
        <mat-option
          *ngFor="let taxpayerType of taxpayerTypes"
          [value]="taxpayerType"
        >
          {{ taxpayerType.Name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="f.taxpayerType.errors && f.taxpayerType.errors.required"
      >
        Ingrese el tipo de contribuyente
      </mat-error>
    </mat-form-field>

    <mat-form-field class="margin-right-small">
      <mat-label>Responsabilidad iibb</mat-label>
      <mat-select
        formControlName="IibbResponsibility"
        name="IibbResponsibility"
        required
      >
        <mat-option
          *ngFor="
            let customerIibbResponsibility of customerIibbResponsibilities
          "
          [value]="customerIibbResponsibility"
        >
          {{ customerIibbResponsibility.Name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          f.IibbResponsibility.errors && f.IibbResponsibility.errors.required
        "
      >
        Ingrese la responsabilidad IIBB
      </mat-error>
    </mat-form-field>


        <mat-form-field class="margin-right-small">
      <mat-label>Alícuota</mat-label>
      <mat-select
        formControlName="AliquotTax"
        name="AliquotTax"
        required
      >
        <mat-option
          *ngFor="
            let aliquotTax of aliquotTaxs
          "
          [value]="aliquotTax"
        >
          {{ aliquotTax.Name }}
        </mat-option>
      </mat-select>

    </mat-form-field>



    <div class="clearfix">
      <div class="pull-right">
        <mat-spinner
          *ngIf="loadingAction"
          matSuffix
          [diameter]="20"
        ></mat-spinner>
        <button *ngIf="!loadingAction" mat-button type="submit">Guardar</button>
        <button
          *ngIf="!loadingAction"
          mat-button
          type="button"
          (click)="onNoClick()"
          cdkFocusInitial
        >
          Salir
        </button>
      </div>
    </div>
  </form>
</div>
